export default __webpack_public_path__ + "static/Museo-Sans-700-Italic-862f3cf7ea4eb03306243919aed19f25.woff";